import VIPRedemptionStatus from "enums/vip-redemption-status";

export const redemptionHistoryFilterState = () => ({
  startDate: null,
  endDate: null,
  statuses: Object.values(VIPRedemptionStatus),
  searchKey: "",
  page: 1,
  perPage: 10,
});
